export default function refreshAccessToken(userType: string) {
    const {REACT_APP_TOKENHANDLER_DOMAIN, REACT_APP_TOKENHANDLER_AUTHORIZE} = process.env;

    window.location.href = `${REACT_APP_TOKENHANDLER_DOMAIN}${REACT_APP_TOKENHANDLER_AUTHORIZE}${userType}`;
}
